function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import metadataThunkHelper from 'invision-core/src/api/metadata.thunk.helper';
import thunkHelper from 'invision-core/src/api/thunk.helper';
import { CUSTOM_SUBSCRIBER_LANGUAGE_HEADER, LANGUAGE_HEADER, SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
import { TRANSFER_WIZARD_PREFIX } from '../constants/wizard.constants';
import createWizardActions from '../helpers/offer.ordering.wizard.action.helper';
var wizardActions = createWizardActions(TRANSFER_WIZARD_PREFIX);
export var updateShoppingCart = wizardActions.updateShoppingCart;
export var VALIDATE_SUBSCRIBER_FOR_TRANSFER = {
  BEGIN: 'VALIDATE_SUBSCRIBER_FOR_TRANSFER_BEGIN',
  SUCCESS: 'VALIDATE_SUBSCRIBER_FOR_TRANSFER_SUCCESS',
  FAILURE: 'VALIDATE_SUBSCRIBER_FOR_TRANSFER_FAILURE'
};
export var VALIDATE_SUBSCRIBER_FOR_TRANSFER_EVENTS = [VALIDATE_SUBSCRIBER_FOR_TRANSFER.BEGIN, VALIDATE_SUBSCRIBER_FOR_TRANSFER.SUCCESS, VALIDATE_SUBSCRIBER_FOR_TRANSFER.FAILURE];
export var RETRIEVE_TRANSFER_DESTINATION_CUSTOMER = {
  BEGIN: 'RETRIEVE_TRANSFER_DESTINATION_CUSTOMER_BEGIN',
  SUCCESS: 'RETRIEVE_TRANSFER_DESTINATION_CUSTOMER_SUCCESS',
  FAILURE: 'RETRIEVE_TRANSFER_DESTINATION_CUSTOMER_FAILURE'
};
export var RETRIEVE_TRANSFER_DESTINATION_CUSTOMER_EVENTS = [RETRIEVE_TRANSFER_DESTINATION_CUSTOMER.BEGIN, RETRIEVE_TRANSFER_DESTINATION_CUSTOMER.SUCCESS, RETRIEVE_TRANSFER_DESTINATION_CUSTOMER.FAILURE];
export var RESET_TRANSFER_WIZARD = 'RESET_TRANSFER_WIZARD';
export var resetTransfer = function resetTransfer() {
  return {
    type: RESET_TRANSFER_WIZARD
  };
};
export var RETRIEVE_TRANSFERABLE_OFFERINGS = {
  BEGIN: 'RETRIEVE_TRANSFERABLE_OFFERINGS_BEGIN',
  SUCCESS: 'RETRIEVE_TRANSFERABLE_OFFERINGS_SUCCESS',
  FAILURE: 'RETRIEVE_TRANSFERABLE_OFFERINGS_FAILURE'
};
var RETRIEVE_TRANSFERABLE_OFFERINGS_EVENTS = [RETRIEVE_TRANSFERABLE_OFFERINGS.BEGIN, RETRIEVE_TRANSFERABLE_OFFERINGS.SUCCESS, RETRIEVE_TRANSFERABLE_OFFERINGS.FAILURE];
var retrieveTransferableOfferingsPromise = function retrieveTransferableOfferingsPromise(dispatch, customerId) {
  return thunkHelper(dispatch, RETRIEVE_TRANSFERABLE_OFFERINGS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveTransferableOfferings',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {}
  });
};
export var retrieveTransferableOfferings = function retrieveTransferableOfferings(customerId) {
  return function (dispatch) {
    return retrieveTransferableOfferingsPromise(dispatch, customerId);
  };
};
export var RETRIEVE_TRANSFER_OFFERING_CONTEXT = {
  BEGIN: 'RETRIEVE_TRANSFER_OFFERING_CONTEXT_BEGIN',
  SUCCESS: 'RETRIEVE_TRANSFER_OFFERING_CONTEXT_SUCCESS',
  FAILURE: 'RETRIEVE_TRANSFER_OFFERING_CONTEXT_FAILURE'
};
var RETRIEVE_TRANSFER_OFFERING_CONTEXT_EVENTS = [RETRIEVE_TRANSFER_OFFERING_CONTEXT.BEGIN, RETRIEVE_TRANSFER_OFFERING_CONTEXT.SUCCESS, RETRIEVE_TRANSFER_OFFERING_CONTEXT.FAILURE];
var retrieveTransferOfferingContextPromise = function retrieveTransferOfferingContextPromise(dispatch, customerId, offerings) {
  return thunkHelper(dispatch, RETRIEVE_TRANSFER_OFFERING_CONTEXT_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveTransferOfferingContext',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Offerings: offerings
    }
  });
};
export var retrieveTransferOfferingContext = function retrieveTransferOfferingContext(customerId, offerings) {
  return function (dispatch) {
    return retrieveTransferOfferingContextPromise(dispatch, customerId, offerings);
  };
};
var GET_OFFERING_METADATA = {
  BEGIN: 'GET_OFFERING_METADATA_BEGIN',
  SUCCESS: 'GET_OFFERING_METADATA_SUCCESS',
  FAILURE: 'GET_OFFERING_METADATA_FAILURE'
};
var GET_OFFERING_METADATA_EVENTS = [GET_OFFERING_METADATA.BEGIN, GET_OFFERING_METADATA.SUCCESS, GET_OFFERING_METADATA.FAILURE];
var getOfferingMetadataPromise = function getOfferingMetadataPromise(dispatch, offeringId, language) {
  return metadataThunkHelper(dispatch, GET_OFFERING_METADATA_EVENTS, {
    url: "Offering/Id/".concat(offeringId),
    headers: _defineProperty({}, LANGUAGE_HEADER, language || undefined)
  });
};
export var getOfferingMetadata = function getOfferingMetadata(offeringId, language) {
  return function (dispatch) {
    return getOfferingMetadataPromise(dispatch, offeringId, language);
  };
};
export var SET_OFFERINGS_METADATA = 'SET_OFFERINGS_METADATA';
export var setOfferingsMetadata = function setOfferingsMetadata(offeringsMetadata) {
  return {
    payload: offeringsMetadata,
    type: SET_OFFERINGS_METADATA
  };
};
export var SELECT_OFFERING_FOR_TRANSFER = 'SELECT_OFFERING_FOR_TRANSFER';
export var selectOfferingForTransfer = function selectOfferingForTransfer(offeringInstanceId) {
  return {
    payload: offeringInstanceId,
    type: SELECT_OFFERING_FOR_TRANSFER
  };
};
export var UNSELECT_OFFERING_FOR_TRANSFER = 'UNSELECT_OFFERING_FOR_TRANSFER';
export var unselectOfferingForTransfer = function unselectOfferingForTransfer(offeringInstanceId) {
  return {
    payload: offeringInstanceId,
    type: UNSELECT_OFFERING_FOR_TRANSFER
  };
};
export var retrieveCustomerPromise = function retrieveCustomerPromise(dispatch, customerId, languageHeader) {
  return thunkHelper(dispatch, RETRIEVE_TRANSFER_DESTINATION_CUSTOMER_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveSubscriber',
    headers: _defineProperty(_defineProperty({}, SUBSCRIBER_ID_HEADER, customerId), CUSTOM_SUBSCRIBER_LANGUAGE_HEADER, languageHeader),
    data: {}
  });
};
var validateSubscriberForServiceTransferPromise = function validateSubscriberForServiceTransferPromise(dispatch, selectedCustomerId, currentCustomerId) {
  return thunkHelper(dispatch, VALIDATE_SUBSCRIBER_FOR_TRANSFER_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/ValidateSubscriberForServiceTransfer',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, currentCustomerId),
    data: {
      SubscriberId: selectedCustomerId
    }
  });
};
export var validateSubscriberForServiceTransfer = function validateSubscriberForServiceTransfer(selectedCustomerId, currentCustomerId) {
  return function (dispatch) {
    return validateSubscriberForServiceTransferPromise(dispatch, selectedCustomerId, currentCustomerId);
  };
};
export var retrieveCustomer = function retrieveCustomer(customerId, languageHeader) {
  return function (dispatch) {
    return retrieveCustomerPromise(dispatch, customerId, languageHeader);
  };
};